<template>
   <section class="walletHistory-wrap pb-3">
      <div class="backto_page">
        <button class="back_arrow" type="button" @click="$router.go(-1)">
            <img src="@/assets/images/back_arr.svg" alt="back_arrow" />
        </button>
        <div class="header-page-title">
            <h3>{{$t('transactions', 'Transactions')}}</h3>
        </div>  
    </div>
      <template v-if="transactionDetails != null && transactionDetails.status != 0">
         <div class="payment-history" :class="['reject_in_process','reject_completed','expired'].includes(transactionDetails.status) ? 'payment-rejected' : '', ['pending','hold'].includes(transactionDetails.status) ? 'payment-pending' : ''" >
            <div class="payment-iocn payment-approved">
                  <img v-if="['approve_completed','approve_in_process'].includes(transactionDetails.status)" src="@/assets/images/payment-approved.svg" alt="payment-approved" loading="lazy">
                  <img v-if="['reject_in_process','reject_completed','expired'].includes(transactionDetails.status)" src="@/assets/images/payment-rejected.svg" alt="payment-rejected" loading="lazy">
                  <img v-if="['pending'].includes(transactionDetails.status)" loading="lazy" src="@/assets/images/payment-processing.svg" alt="processing-payment">
                  <img v-if="['hold'].includes(transactionDetails.status)" loading="lazy" src="@/assets/images/hold_icon.svg" alt="processing-payment">
            </div>
            <div class="request_title">
                  <h3>{{ transactionDetails?.user_name }}</h3>
                  <p>{{ transactionDetails?.type?.includes('deposit') ? 'Deposit' : 'Withdrawal'}} Request {{toTitleCaseWithSpaces(transactionDetails?.status)}}</p>
            </div>
         </div>
         <div class="container">
               <div class="historyDet-wrap">
                  <div class="historyDet-items">
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('requested-amount', 'Requested Amount')}}</span>
                           <span class="historyDet-value">{{ transactionDetails.amount }}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{['approve_completed','approve_in_process'].includes(transactionDetails.status) ? $t('accepted-amount', 'Accepted Amount') : (['reject_in_process','reject_completed','expired'].includes(transactionDetails.status) ? $t('rejected-amount', 'Rejected Amount') : $t('processing-amount', 'Processing Amount'))}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.approved_amount }}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('request-date', 'Request Date')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.created_at ? $dateTime.getLocalDate(transactionDetails?.created_at, 'DD MMM YYYY hh:mm:ss A') : '-'}}</span>
                        </div>
                        <div class="historyDet-item" v-if="transactionDetails.status == 'hold'">
                           <span class="historyDet-key">{{$t('action-on', 'Action on')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.hold_at ? $dateTime.getLocalDate(transactionDetails?.hold_at, 'DD MMM YYYY hh:mm:ss A') : '-'}}</span>
                        </div>
                        <div class="historyDet-item" v-else>
                           <span class="historyDet-key">{{$t('action-on', 'Action on')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.action_at ? $dateTime.getLocalDate(transactionDetails?.action_at, 'DD MMM YYYY hh:mm:ss A') : '-'}}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('reference-no', 'Reference No.')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.transaction_id }}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('remarks', 'Remarks')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.remark !== 'null' ? transactionDetails?.remark : '-' }}</span>
                        </div>
                        <!-- <span class="historyDet-value" :class="item?.type == 2 ? 'statusDeposit' : 'statusWithdraw'">{{ item?.type == 2 ? "Deposit" : "Withdraw" }}</span> -->
                        <!-- <div class="historyDet-item">
                           <span class="historyDet-key">Status</span>
                           <span class="historyDet-value status-type">{{ item?.status }}</span>
                        </div> -->
                  </div>
                  <div class="withdraw-fix-sec continue-btn">
                        <!-- <span class="withdraw-btn deposit-btn">
                           <a href="#walleteditstackModal" data-bs-toggle="modal" class="thm-but">
                              <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                              <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                           </a>
                        </span>
                        <a href="javascript:void(0);" class="thm-but" id="account-successfully" data-bs-toggle="modal" data-bs-target="#instructionsModal">{{ $t('proceed','Proceed') }} </a> -->
                        <div class="view-details">
                              <button type="button" class="thm-but back_btn_link" data-bs-toggle="modal" data-bs-target="#transactionModal">{{ $t('view-details','View details') }}</button>
                           </div>
                        <div class="button-whatsapp" v-if="$siteSettings.data && $siteSettings.data?.social_link && $siteSettings.data?.social_link.whatsappno1">
                           <a type="button" class="btn-whatsapp" :href="'//wa.me/' + $siteSettings.data.social_link.whatsappno1" target="_blank">
                              <img src="@/assets/images/whatsapp.png" alt="whatsapp" />
                              {{ $t('customer-support','Customer support') }}
                           </a>
                        </div>
                  </div>
               </div>        
         </div>
      </template>
   </section>
    <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header">
               <div class="thm-heading">
                  <h3>{{ $t('details','Details') }}</h3>
               </div>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <div v-if="transactionImageLists?.length">
                  <div class="transactionImage-wrap">
                     <div class="transactionImage-item" v-for="(img, iIndex) in transactionImageLists" :key="iIndex">
                        <a :href="img" download target="_blank">
                           <img :src="img" height="100%" width="100px" />
                        </a>
                     </div>
                  </div>
               </div>
               <div v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
   name: 'TransactionDetails',
   data(){
      return{
         transactionId: null,
      }
   },
   computed:{
      ...mapGetters(['transactionDetails']),
      transactionImageLists() {
         return this.transactionDetails?.transaction_image_url?.split(',')
      },
   },
   mounted(){
      this.transactionId = this.$route?.params?.id
   },
   methods:{
      toTitleCaseWithSpaces(str) {
         return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
      },
      getTransactionStatus(status){
            switch (status) {
               case 0 :
                  return 'Pending';
               case 1 :
                  return 'Approved';
               case 2 :
                  return 'Rejected';
               case 3 :
                  return 'Canceled';
               case 4 :
                  return 'Closed';
            }
      },
      generateUID(length) {
         return window.btoa(String.fromCharCode(...window.crypto.getRandomValues(new Uint8Array(length * 2)))).replace(/[+/]/g, "").substring(0, length);
      },
      getRemarks(requestImages) {
         var remark = '';
         remark = requestImages.find(e => e.remarks != null);
         if (remark) {
               remark = remark.remarks;
         }
         return remark;
      },
      getImageBy(data) {
         if (data == 2) {
            return "By me";
         } else if (data == 3) {
            return "By Admin";
         } 
      },
   }
}
</script>

<style scoped>
.btn-whatsapp:hover{
   color: #fff;
}
</style>